import { Gaussian2D } from "./gaussian2D/Gaussian2D.js";
export function getShape2D(shape) {
    const { kind } = shape;
    switch (kind) {
        case 'gaussian':
            return new Gaussian2D(shape);
        default:
            throw new Error(`Unknown distribution ${kind}`);
    }
}
//# sourceMappingURL=getShape2D.js.map